export { default } from "./LessonMediaClipWithThumbnail";
